// Locks event-ticket cart lines to quantity 1.
// Each ticket is one line item — buyer details (attendee/vehicle/dinner) are captured
// per line, not per unit — so a quantity > 1 would tie one detail set to several tickets.
// Runs SITE-WIDE via the footer section group (sections/event-ticket-cart-guard.liquid)
// so the cart drawer is guarded too, not just the /cart page. Identifies event-ticket
// lines by the line-item properties the event-ticket-details block submits, hides their
// quantity stepper, and resets any line with qty > 1 back to 1.
(function () {
  // Presence of any of these line-item properties marks a line as an event-ticket line.
  var TICKET_PROPS = [
    'Attendee Name',
    'Vehicle Year',
    'Vehicle Make',
    'Vehicle Model',
    'Vehicle Class',
    'Dietary Restrictions',
    'Guest Name (+1)',
    'Guest Dietary Restrictions',
  ];

  var RESET_FLAG = 'evtTicketQtyReset';

  function isTicketItem(item) {
    var props = item.properties || {};
    return TICKET_PROPS.some(function (key) {
      return props[key] != null && String(props[key]).length > 0;
    });
  }

  function rowForKey(key) {
    var rows = document.querySelectorAll('[data-key]');
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAttribute('data-key') === key) return rows[i];
    }
    return null;
  }

  // Replace the interactive stepper on a ticket line with a static "1".
  function lockRow(key) {
    var row = rowForKey(key);
    if (!row) return;
    var wrapper = row.querySelector('.quantity-selector-wrapper');
    if (!wrapper || wrapper.dataset.ticketLocked === 'true') return;
    wrapper.dataset.ticketLocked = 'true';
    wrapper.hidden = true;
    var note = document.createElement('span');
    note.className = 'event-ticket-qty-locked';
    note.textContent = '1';
    note.setAttribute('aria-label', 'Quantity is limited to 1 for event tickets');
    wrapper.parentNode.insertBefore(note, wrapper);
  }

  // Show a one-time notice after we silently reset an over-quantity line.
  function showResetNotice() {
    if (sessionStorage.getItem(RESET_FLAG) !== '1') return;
    sessionStorage.removeItem(RESET_FLAG);
    var anchor = document.querySelector('.cart-items') || document.querySelector('main');
    if (!anchor || document.querySelector('.event-ticket-cart-notice')) return;
    var notice = document.createElement('p');
    notice.className = 'event-ticket-cart-notice';
    notice.setAttribute('role', 'status');
    notice.textContent =
      'Event tickets are limited to one per line so each registration captures its own details. ' +
      'A ticket quantity was reset to 1 — add the package again to register another attendee.';
    anchor.parentNode.insertBefore(notice, anchor);
  }

  var working = false;

  function enforce() {
    if (working) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var overQty = [];
        (cart.items || []).forEach(function (item) {
          if (!isTicketItem(item)) return;
          lockRow(item.key);
          if (item.quantity > 1) overQty.push(item.key);
        });
        if (overQty.length === 0) return;
        working = true;
        var chain = Promise.resolve();
        overQty.forEach(function (key) {
          chain = chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: key, quantity: 1 }),
            });
          });
        });
        chain.then(function () {
          sessionStorage.setItem(RESET_FLAG, '1');
          window.location.reload();
        });
      })
      .catch(function () {
        /* network/parse errors are non-fatal — the page still functions */
      });
  }

  function init() {
    showResetNotice();
    enforce();
    // Horizon re-renders the cart section on add/remove/update; re-apply the lock after.
    document.addEventListener('cart:update', function () {
      window.setTimeout(enforce, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
